import * as React from "react";
const ModalFooter = (props) => {
  const { children, isSticky, className } = props;
  const BEM = () => {
    const classArray = ["modal__footer"];
    if (isSticky) {
      classArray.push("modal__footer--sticky");
    }
    if (className) {
      classArray.push(className);
    }
    return classArray.join(" ");
  };
  return /* @__PURE__ */ React.createElement("div", { className: BEM() }, children);
};
export {
  ModalFooter
};
